import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const EnergyReport: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/EnergyReport.${label}.${locale}.json`)}>
      <EnergyReportComponent />
    </I18nProvider>
  );
};

export const EnergyReportComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.EnergyReport'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('energyReport.title')}
      content={t('energyReport.content')}
      buttonHref={t('energyReport.buttonLink.href')}
      buttonText={t('energyReport.buttonLink.text')}
      nextStepList={[
        {
          label: t('energyReport.nextStep1'),
          state: 0,
        },
        {
          label: t('energyReport.nextStep2'),
          state: 0,
        },
        {
          label: t('energyReport.nextStep3'),
          state: 1,
        },
      ]}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('energyReport.imageSrc')}`,
        },
      }}
    />
  );
};
